import { JZKRate, JZKRateApi } from '../types';

// Currency to country mapping with translation keys
export const currencyMapping: Record<string, { countryKey: string }> = {
  CHF: { countryKey: 'country.switzerland' },
  DKK: { countryKey: 'country.denmark' },
  EUR: { countryKey: 'country.emu' },
  HUF: { countryKey: 'country.hungary' },
  PLN: { countryKey: 'country.poland' },
  SEK: { countryKey: 'country.sweden' },
  UAH: { countryKey: 'country.ukraine' },
  XDR: { countryKey: 'country.xdr' },
  GBP: { countryKey: 'country.uk' },
  USD: { countryKey: 'country.usa' },
  NOK: { countryKey: 'country.norway' },
  SKK: { countryKey: 'country.slovakia' },
  BGN: { countryKey: 'country.bulgaria' },
  RUB: { countryKey: 'country.russia' },
  TRY: { countryKey: 'country.turkey' },
  RON: { countryKey: 'country.romania' },
  HRK: { countryKey: 'country.croatia' },
  RSD: { countryKey: 'country.serbia' },
  MKD: { countryKey: 'country.macedonia' },
};

// Group rates by currency and keep the latest ones
const getLatestRates = (items: JZKRateApi[]): Map<string, JZKRateApi> => {
  const rateMap = new Map<string, JZKRateApi[]>();

  // Group by currency
  items.forEach((item) => {
    const existing = rateMap.get(item.currency_from) || [];
    existing.push(item);
    rateMap.set(item.currency_from, existing);
  });

  // Get latest rate for each currency (last item in array)
  const latestRates = new Map<string, JZKRateApi>();
  rateMap.forEach((rates, currency) => {
    if (rates.length > 0) {
      latestRates.set(currency, rates[rates.length - 1]);
    }
  });

  return latestRates;
};

// Process API rates to display format
export const processRates = (items: JZKRateApi[]): JZKRate[] => {
  const latestRates = getLatestRates(items);
  const processedRates: JZKRate[] = [];

  latestRates.forEach((apiRate, currency) => {
    const mapping = currencyMapping[currency];

    // For known currencies, use mapping
    // For unknown currencies, create a default entry
    const countryKey = mapping?.countryKey || `country.${currency.toLowerCase()}`;

    processedRates.push({
      countryKey,
      currency,
      amount: apiRate.amount_from,
      code: currency,
      rate: apiRate.rate,
      trend: apiRate.trend, // Use trend from API
    });
  });

  // Return rates in the order they appear in the API response
  return processedRates;
};
